/**
 * El backend nunca devuelve el secreto guardado. Un guardado sin texto nuevo
 * debe conservarlo, así que el campo solo viaja cuando el negocio escribe uno.
 */
export function buildOutboundSecretPayload(secret: string): { outboundWebhookSecret?: string } {
  const trimmed = secret.trim()
  return trimmed ? { outboundWebhookSecret: trimmed } : {}
}
